export default __webpack_public_path__ + "static/remeltedwax-2d3ed4c1f28c7d1a710addac07dfb356.png";